<template>
  <v-layout>
    <div class="section">
      <div class="container">
        <div
          v-if="!loading && !error && user"
          class="is-fullwidth is-flex is-align-items-flex-start gap-4"
        >
          <img
            class="is-250x200"
            :src="userProfilePicture"
          >
          <v-description class="is-fullwidth">
            <v-description-item>
              <template #left>
                {{ $t('name').capitalize() }}
              </template>

              <template #right>
                <p>
                  {{ user.name }}
                </p>
              </template>
            </v-description-item>

            <v-description-item>
              <template #left>
                {{ $t('experience') }}
              </template>

              <template #right>
                <p>
                  {{ user.experience }}
                </p>
              </template>
            </v-description-item>

            <v-description-item>
              <template #left>
                {{ $t('bio') }}
              </template>

              <template #right>
                <div v-html="user.bio" />
              </template>
            </v-description-item>
          </v-description>
        </div>
        <div
          v-if="!loading && error"
          class="notification is-danger"
        >
          {{ $t("user_not_found") }}
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>

import BaseDescriptionList from "@/shared/components/BaseDescriptionList.vue";
import BaseDescriptionListItem from "@/shared/components/BaseDescriptionListItem.vue";

export default {
  components: {
    "v-description": BaseDescriptionList,
    "v-description-item": BaseDescriptionListItem,
  },
  data() {
    return {
      user: {},
      loading: true,
      error: false,
    };
  },
  computed: {
    title() {
      return this.user?.name || "";
    },
    userProfilePicture() {

      if (typeof this.user.avatar === "object" && this.user.avatar !== null) {
        return this.user.avatar.url;
      }

      if (typeof this.user.avatar === "string") {
        return this.user.avatar;
      }

      return null;
    },
  },
  watch: {
    "$route.params.rentAgentId": {
      immediate: true,
      handler() {
        this.fetch();
      },
    },
  },
  methods: {
    fetch() {
      this.loading = true;
      this.error = false ;
      this.$http
        .get(route("public.user.show", { user: this.$route.params.rentAgentId }))
        .then((response) => {
          this.user = response.data.data;
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.is-250x200 {
  width: 250px;
  height: 200px;
  object-fit: cover;
}
.is-fullwidth {
  width: 100%;
}
.gap-4 {
  gap: 2rem;
}
</style>
